import axios from 'axios'
import {convertToRupiah} from '../../../_metronic/helpers/currency'

const API_URLS = process.env.REACT_APP_API_URLS

export interface Filter {
  field: string | null
  type: string | null
}

export const getDepartmentList = async (search?: string, page?: number, filter?: Filter) => {
  let url = `${API_URLS}/departments?populate=*&`
  if (page) url += `pagination[pageSize]=5&pagination[page]=${page}&`
  if (search) url += `_q=${search}&`
  if (filter?.field && filter.type) url += `filters${filter.field}=${filter.type}`
  try {
    const response = await axios.get(url)
    if (response.data.data.length > 0) {
      return Promise.resolve({
        ...response.data,
        data: response.data.data.map((e: any) => ({
          ...e,
          attributes: {
            ...e.attributes,
            annual_budget_format: convertToRupiah(e.attributes.annual_budget),
            kpi_redemption_format: `${e.attributes.kpi_redemption}%`,
            conversion: `${convertToRupiah(e.attributes.spending)}/${
              e.attributes.point_conversation
            }`,
          },
        })),
      })
    }
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getDepartmentById = async (id: any) => {
  let url = `${API_URLS}/departments/${id}?populate=*`
  try {
    const response = await axios.get(url)
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const deleteDepartment = async (id: any) => {
  let url = `${API_URLS}/departments/${id}`
  try {
    const response = await axios.delete(url)
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const putDepartment = async (datas: any) => {
  try {
    const response = await axios.put(`${API_URLS}/departments/${datas.id}`, datas.form)
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const postDepartment = async (datas: any) => {
  try {
    const response = await axios.post(`${API_URLS}/departments`, {data: datas})
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}
